module.exports = __webpack_public_path__ + "img/index18.e0d10a08.png";